// The CA police / sheriff agency list (Neila 2026-10-13), the same data as lib/claims_controller/ca_pd_agencies.json (a test checks
// they are equal). Built by scripts/dev/build_ca_pd_agencies.py; do not edit by hand. Agency facts only, no case data.
export const CA_PD_AGENCIES = {
    "source": "CA PD Agency List (Neila, Maria Frias's OneDrive), read 2026-10-13; raw copy in the Ins Creation working folder (reference/ca_pd_agency_list_20261013.json). Built by scripts/dev/build_ca_pd_agencies.py; do not edit by hand.",
    "default_wait_days": 30,
    "agencies": [
        {
            "id": "california_highway_patrol",
            "name": "California Highway Patrol",
            "short": "CHP",
            "type": "state",
            "city": "Statewide",
            "county": null,
            "aliases": [
                "CALIFORNIA HIGHWAY PATROL",
                "CHP",
                "HIGHWAY PATROL"
            ],
            "county_aliases": [],
            "tat_text": "Minimum of 8 business days",
            "tat_min_days": 12,
            "tat_max_days": null,
            "wait_text": "a minimum of 8 business days",
            "status": "Needs Confirmation",
            "request_method": "Online CHP crash report request, mail request, or CHP Area office Records Unit",
            "website": null,
            "website_label": "CHP Crash Report Request",
            "phone": "1-800-TELL-CHP (1-800-835-5247)",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "los_angeles_police_department",
            "name": "Los Angeles Police Department",
            "short": "LAPD",
            "type": "police",
            "city": "Los Angeles",
            "county": "Los Angeles",
            "aliases": [
                "CITY OF LOS ANGELES POLICE",
                "CITY OF LOS ANGELES POLICE DEPARTMENT",
                "LAPD",
                "LOS ANGELES PD",
                "LOS ANGELES POLICE",
                "LOS ANGELES POLICE DEPARTMENT"
            ],
            "county_aliases": [],
            "tat_text": "8 months to a year",
            "tat_min_days": 240,
            "tat_max_days": 365,
            "wait_text": "8 months to a year",
            "status": "Needs Confirmation",
            "request_method": "Online Traffic Collision Report request portal, mail, or LAPD Records Division",
            "website": null,
            "website_label": "LAPD Traffic Collision Report Request",
            "phone": "877-ASK-LAPD (877-275-5273)",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "los_angeles_county_sheriff",
            "name": "Los Angeles County Sheriff's Office",
            "short": "LASD",
            "type": "sheriff",
            "city": "Los Angeles County",
            "county": "Los Angeles",
            "aliases": [
                "LA COUNTY SHERIFF",
                "LACO SHERIFF",
                "LACSD",
                "LASD",
                "LOS ANGELES COUNTY SHERIFF",
                "LOS ANGELES COUNTY SHERIFF DEPARTMENT",
                "LOS ANGELES COUNTY SHERIFF OFFICE",
                "LOS ANGELES COUNTY SO",
                "LOS ANGELES SHERIFF",
                "LOS ANGELES SHERIFF DEPARTMENT",
                "LOS ANGELES SHERIFF OFFICE",
                "LOS ANGELES SO"
            ],
            "county_aliases": [],
            "tat_text": "8 months to a year",
            "tat_min_days": 240,
            "tat_max_days": 365,
            "wait_text": "8 months to a year",
            "status": "Needs Confirmation",
            "request_method": "Online LASD Records request, mail, or station Records Bureau",
            "website": "https://lasd.org/records/",
            "website_label": "LASD Records & ID Bureau",
            "phone": "877-ASK-LASD (877-275-5273)",
            "sheet": "Sheet1",
            "conflicts": [
                {
                    "sheet": "Sheet2",
                    "name": "Los Angeles County Sheriff's Department",
                    "tat_text": "15 - 30 days",
                    "website": "https://lasd.org/records/"
                }
            ]
        },
        {
            "id": "san_diego_police_department",
            "name": "San Diego Police Department",
            "short": "SDPD",
            "type": "police",
            "city": "San Diego",
            "county": "San Diego",
            "aliases": [
                "CITY OF SAN DIEGO POLICE",
                "CITY OF SAN DIEGO POLICE DEPARTMENT",
                "SAN DIEGO PD",
                "SAN DIEGO POLICE",
                "SAN DIEGO POLICE DEPARTMENT",
                "SDPD"
            ],
            "county_aliases": [],
            "tat_text": "30 days",
            "tat_min_days": 30,
            "tat_max_days": 30,
            "wait_text": "about 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online SDPD Police Report request, mail, or Records Division",
            "website": "https://www.sandiego.gov/police/services/units/records",
            "website_label": null,
            "phone": "619-531-2000",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "san_francisco_police_department",
            "name": "San Francisco Police Department",
            "short": "SFPD",
            "type": "police",
            "city": "San Francisco",
            "county": "San Francisco",
            "aliases": [
                "CITY OF SAN FRANCISCO POLICE",
                "CITY OF SAN FRANCISCO POLICE DEPARTMENT",
                "SAN FRANCISCO PD",
                "SAN FRANCISCO POLICE",
                "SAN FRANCISCO POLICE DEPARTMENT",
                "SFPD"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online SFPD Records Request, mail, or Records Management Division",
            "website": "https://www.sanfranciscopolice.org/your-sfpd/records",
            "website_label": null,
            "phone": "415-553-0123",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "san_jose_police_department",
            "name": "San Jose Police Department",
            "short": "SJPD",
            "type": "police",
            "city": "San Jose",
            "county": "Santa Clara",
            "aliases": [
                "CITY OF SAN JOSE POLICE",
                "CITY OF SAN JOSE POLICE DEPARTMENT",
                "SAN JOSE PD",
                "SAN JOSE POLICE",
                "SAN JOSE POLICE DEPARTMENT",
                "SJPD"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online SJPD Records request, mail, or Records Unit",
            "website": "https://www.sjpd.org/records",
            "website_label": null,
            "phone": "408-277-8900",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "oakland_police_department",
            "name": "Oakland Police Department",
            "short": "Oakland PD",
            "type": "police",
            "city": "Oakland",
            "county": "Alameda",
            "aliases": [
                "CITY OF OAKLAND POLICE",
                "CITY OF OAKLAND POLICE DEPARTMENT",
                "OAKLAND PD",
                "OAKLAND POLICE",
                "OAKLAND POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "OPD"
            ],
            "tat_text": "6-8 months",
            "tat_min_days": 180,
            "tat_max_days": 240,
            "wait_text": "6 to 8 months",
            "status": "Needs Confirmation",
            "request_method": "OPD Records Division request (online/mail/in person)",
            "website": "https://www.oaklandca.gov/departments/police/records",
            "website_label": null,
            "phone": "510-777-3333",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "sacramento_police_department",
            "name": "Sacramento Police Department",
            "short": "Sacramento Police Department",
            "type": "police",
            "city": "Sacramento",
            "county": "Sacramento",
            "aliases": [
                "CITY OF SACRAMENTO POLICE",
                "CITY OF SACRAMENTO POLICE DEPARTMENT",
                "SACRAMENTO PD",
                "SACRAMENTO POLICE",
                "SACRAMENTO POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "SPD"
            ],
            "tat_text": "5-10 (estimated)",
            "tat_min_days": 5,
            "tat_max_days": 10,
            "wait_text": "5 to 10 days (estimated)",
            "status": "Estimated",
            "request_method": "Online Sacramento Police Records request, mail, or Records Division",
            "website": "https://www.cityofsacramento.gov/police/records",
            "website_label": null,
            "phone": "916-808-5471",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "riverside_police_department",
            "name": "Riverside Police Department",
            "short": "Riverside Police Department",
            "type": "police",
            "city": "Riverside",
            "county": "Riverside",
            "aliases": [
                "CITY OF RIVERSIDE POLICE",
                "CITY OF RIVERSIDE POLICE DEPARTMENT",
                "RIVERSIDE PD",
                "RIVERSIDE POLICE",
                "RIVERSIDE POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "RPD"
            ],
            "tat_text": "10+ (estimated)",
            "tat_min_days": 10,
            "tat_max_days": null,
            "wait_text": "10+ days (estimated)",
            "status": "Estimated",
            "request_method": "Online RPD Police Report request, mail, or Records Bureau",
            "website": "https://www.riversideca.gov/rpd/records",
            "website_label": null,
            "phone": "951-353-7211",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "fresno_police_department",
            "name": "Fresno Police Department",
            "short": "Fresno Police Department",
            "type": "police",
            "city": "Fresno",
            "county": "Fresno",
            "aliases": [
                "CITY OF FRESNO POLICE",
                "CITY OF FRESNO POLICE DEPARTMENT",
                "FRESNO PD",
                "FRESNO POLICE",
                "FRESNO POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "FPD"
            ],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online Fresno Police Records request, mail, or Records Division",
            "website": "https://www.fresno.gov/police/records",
            "website_label": null,
            "phone": "559-621-7000",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "anaheim_police_department",
            "name": "Anaheim Police Department",
            "short": "Anaheim Police Department",
            "type": "police",
            "city": "Anaheim",
            "county": "Orange",
            "aliases": [
                "ANAHEIM PD",
                "ANAHEIM POLICE",
                "ANAHEIM POLICE DEPARTMENT",
                "CITY OF ANAHEIM POLICE",
                "CITY OF ANAHEIM POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "APD"
            ],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online Anaheim Police Report request, mail, or Records Section",
            "website": "https://www.anaheim.net/784/Police-Reports",
            "website_label": null,
            "phone": "714-765-1900",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "bakersfield_police_department",
            "name": "Bakersfield Police Department",
            "short": "Bakersfield Police Department",
            "type": "police",
            "city": "Bakersfield",
            "county": "Kern",
            "aliases": [
                "BAKERSFIELD PD",
                "BAKERSFIELD POLICE",
                "BAKERSFIELD POLICE DEPARTMENT",
                "CITY OF BAKERSFIELD POLICE",
                "CITY OF BAKERSFIELD POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "BPD"
            ],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online BPD Records request, mail, or Records Division",
            "website": "https://www.bakersfieldcity.us/records",
            "website_label": null,
            "phone": "661-327-7111",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "berkeley_police_department",
            "name": "Berkeley Police Department",
            "short": "Berkeley Police Department",
            "type": "police",
            "city": "Berkeley",
            "county": "Alameda",
            "aliases": [
                "BERKELEY PD",
                "BERKELEY POLICE",
                "BERKELEY POLICE DEPARTMENT",
                "CITY OF BERKELEY POLICE",
                "CITY OF BERKELEY POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "BPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online Berkeley Police Records request, mail, or Records Unit",
            "website": "https://www.berkeleyca.gov/community-safety/police-services/records",
            "website_label": null,
            "phone": "510-981-5900",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "fremont_police_department",
            "name": "Fremont Police Department",
            "short": "Fremont Police Department",
            "type": "police",
            "city": "Fremont",
            "county": "Alameda",
            "aliases": [
                "CITY OF FREMONT POLICE",
                "CITY OF FREMONT POLICE DEPARTMENT",
                "FREMONT PD",
                "FREMONT POLICE",
                "FREMONT POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "FPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online Fremont Police Report request, mail, or Records Division",
            "website": "https://www.fremont.gov/government/departments/police/records",
            "website_label": null,
            "phone": "510-790-6800",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "irvine_police_department",
            "name": "Irvine Police Department",
            "short": "Irvine Police Department",
            "type": "police",
            "city": "Irvine",
            "county": "Orange",
            "aliases": [
                "CITY OF IRVINE POLICE",
                "CITY OF IRVINE POLICE DEPARTMENT",
                "IRVINE PD",
                "IRVINE POLICE",
                "IRVINE POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "IPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online Irvine Police Records request, mail, or Records Bureau",
            "website": "https://www.cityofirvine.org/ipd-divisions/records",
            "website_label": null,
            "phone": "949-724-7200",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "long_beach_police_department",
            "name": "Long Beach Police Department",
            "short": "LBPD",
            "type": "police",
            "city": "Long Beach",
            "county": "Los Angeles",
            "aliases": [
                "CITY OF LONG BEACH POLICE",
                "CITY OF LONG BEACH POLICE DEPARTMENT",
                "LBPD",
                "LONG BEACH PD",
                "LONG BEACH POLICE",
                "LONG BEACH POLICE DEPARTMENT"
            ],
            "county_aliases": [],
            "tat_text": "6-8 months",
            "tat_min_days": 180,
            "tat_max_days": 240,
            "wait_text": "6 to 8 months",
            "status": "Needs Confirmation",
            "request_method": "Online LBPD Report Request, mail, or Records Division",
            "website": "https://www.longbeach.gov/police/how-do-i/request-a-police-report",
            "website_label": null,
            "phone": "562-435-6711",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "santa_ana_police_department",
            "name": "Santa Ana Police Department",
            "short": "Santa Ana Police Department",
            "type": "police",
            "city": "Santa Ana",
            "county": "Orange",
            "aliases": [
                "CITY OF SANTA ANA POLICE",
                "CITY OF SANTA ANA POLICE DEPARTMENT",
                "SANTA ANA PD",
                "SANTA ANA POLICE",
                "SANTA ANA POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "SAPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online SAPD Records request, mail, or Records Bureau",
            "website": "https://www.santa-ana.org/police/records",
            "website_label": null,
            "phone": "714-834-4211",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "fullerton_police_department",
            "name": "Fullerton Police Department",
            "short": "Fullerton Police Department",
            "type": "police",
            "city": "Fullerton",
            "county": "Orange",
            "aliases": [
                "CITY OF FULLERTON POLICE",
                "CITY OF FULLERTON POLICE DEPARTMENT",
                "FULLERTON PD",
                "FULLERTON POLICE",
                "FULLERTON POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "FPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online Fullerton Police Report request, mail, or Records Division",
            "website": "https://www.cityoffullerton.com/government/departments/police/records",
            "website_label": null,
            "phone": "714-738-6700",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "glendale_police_department",
            "name": "Glendale Police Department",
            "short": "Glendale Police Department",
            "type": "police",
            "city": "Glendale",
            "county": "Los Angeles",
            "aliases": [
                "CITY OF GLENDALE POLICE",
                "CITY OF GLENDALE POLICE DEPARTMENT",
                "GLENDALE PD",
                "GLENDALE POLICE",
                "GLENDALE POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "GPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Glendale Police Records request, mail, or Records Bureau",
            "website": "https://www.glendaleca.gov/government/departments/police",
            "website_label": null,
            "phone": "818-548-4911",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "pasadena_police_department",
            "name": "Pasadena Police Department",
            "short": "Pasadena Police Department",
            "type": "police",
            "city": "Pasadena",
            "county": "Los Angeles",
            "aliases": [
                "CITY OF PASADENA POLICE",
                "CITY OF PASADENA POLICE DEPARTMENT",
                "PASADENA PD",
                "PASADENA POLICE",
                "PASADENA POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "PPD"
            ],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online Pasadena Police Records request, mail, or Records Section",
            "website": "https://www.cityofpasadena.net/police/records",
            "website_label": null,
            "phone": "626-744-4501",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "oxnard_police_department",
            "name": "Oxnard Police Department",
            "short": "Oxnard Police Department",
            "type": "police",
            "city": "Oxnard",
            "county": "Ventura",
            "aliases": [
                "CITY OF OXNARD POLICE",
                "CITY OF OXNARD POLICE DEPARTMENT",
                "OXNARD PD",
                "OXNARD POLICE",
                "OXNARD POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "OPD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": "Online Oxnard Police Report request, mail, or Records Division",
            "website": "https://www.oxnardpd.org/records",
            "website_label": null,
            "phone": "805-385-7600",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "ventura_police_department",
            "name": "Ventura Police Department",
            "short": "Ventura Police Department",
            "type": "police",
            "city": "Ventura",
            "county": "Ventura",
            "aliases": [
                "CITY OF VENTURA POLICE",
                "CITY OF VENTURA POLICE DEPARTMENT",
                "VENTURA PD",
                "VENTURA POLICE",
                "VENTURA POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "VPD"
            ],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online Ventura Police Records request, mail, or Records Bureau",
            "website": "https://www.cityofventura.ca.gov/Police/Records",
            "website_label": null,
            "phone": "805-650-8010",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "santa_barbara_police_department",
            "name": "Santa Barbara Police Department",
            "short": "Santa Barbara Police Department",
            "type": "police",
            "city": "Santa Barbara",
            "county": "Santa Barbara",
            "aliases": [
                "CITY OF SANTA BARBARA POLICE",
                "CITY OF SANTA BARBARA POLICE DEPARTMENT",
                "SANTA BARBARA PD",
                "SANTA BARBARA POLICE",
                "SANTA BARBARA POLICE DEPARTMENT"
            ],
            "county_aliases": [
                "SBPD"
            ],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": "Online SBPD Records request, mail, or Records Division",
            "website": "https://santabarbaraca.gov/government/departments/police/records",
            "website_label": null,
            "phone": "805-882-8900",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "rialto_police_department",
            "name": "Rialto Police Department",
            "short": "Rialto Police Department",
            "type": "police",
            "city": "Rialto",
            "county": null,
            "aliases": [
                "CITY OF RIALTO POLICE",
                "CITY OF RIALTO POLICE DEPARTMENT",
                "RIALTO PD",
                "RIALTO POLICE",
                "RIALTO POLICE DEPARTMENT"
            ],
            "county_aliases": [],
            "tat_text": null,
            "tat_min_days": null,
            "tat_max_days": null,
            "wait_text": null,
            "status": null,
            "request_method": null,
            "website": null,
            "website_label": null,
            "phone": "909-820-2550",
            "sheet": "Sheet1",
            "conflicts": []
        },
        {
            "id": "alameda_county_sheriff",
            "name": "Alameda County Sheriff's Office",
            "short": "Alameda County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Alameda",
            "aliases": [
                "ACSO",
                "ALAMEDA COUNTY SHERIFF",
                "ALAMEDA COUNTY SHERIFF DEPARTMENT",
                "ALAMEDA COUNTY SHERIFF OFFICE",
                "ALAMEDA COUNTY SO",
                "ALAMEDA SHERIFF",
                "ALAMEDA SHERIFF DEPARTMENT",
                "ALAMEDA SHERIFF OFFICE",
                "ALAMEDA SO"
            ],
            "county_aliases": [],
            "tat_text": "30-60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.alamedacountysheriff.org/services/records",
            "website_label": null,
            "phone": "(510) 667-7721",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "alpine_county_sheriff",
            "name": "Alpine County Sheriff's Office",
            "short": "Alpine County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Alpine",
            "aliases": [
                "ALPINE COUNTY SHERIFF",
                "ALPINE COUNTY SHERIFF DEPARTMENT",
                "ALPINE COUNTY SHERIFF OFFICE",
                "ALPINE COUNTY SO",
                "ALPINE SHERIFF",
                "ALPINE SHERIFF DEPARTMENT",
                "ALPINE SHERIFF OFFICE",
                "ALPINE SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.alpinecountyca.gov/",
            "website_label": null,
            "phone": "(530) 694-2231",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "amador_county_sheriff",
            "name": "Amador County Sheriff's Office",
            "short": "Amador County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Amador",
            "aliases": [
                "AMADOR COUNTY SHERIFF",
                "AMADOR COUNTY SHERIFF DEPARTMENT",
                "AMADOR COUNTY SHERIFF OFFICE",
                "AMADOR COUNTY SO",
                "AMADOR SHERIFF",
                "AMADOR SHERIFF DEPARTMENT",
                "AMADOR SHERIFF OFFICE",
                "AMADOR SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.amadorsheriff.org/",
            "website_label": null,
            "phone": "(209) 223-6513",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "butte_county_sheriff",
            "name": "Butte County Sheriff's Office",
            "short": "Butte County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Butte",
            "aliases": [
                "BUTTE COUNTY SHERIFF",
                "BUTTE COUNTY SHERIFF DEPARTMENT",
                "BUTTE COUNTY SHERIFF OFFICE",
                "BUTTE COUNTY SO",
                "BUTTE SHERIFF",
                "BUTTE SHERIFF DEPARTMENT",
                "BUTTE SHERIFF OFFICE",
                "BUTTE SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.buttecounty.net/sheriff",
            "website_label": null,
            "phone": "(530) 538-7322",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "calaveras_county_sheriff",
            "name": "Calaveras County Sheriff's Office",
            "short": "Calaveras County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Calaveras",
            "aliases": [
                "CALAVERAS COUNTY SHERIFF",
                "CALAVERAS COUNTY SHERIFF DEPARTMENT",
                "CALAVERAS COUNTY SHERIFF OFFICE",
                "CALAVERAS COUNTY SO",
                "CALAVERAS SHERIFF",
                "CALAVERAS SHERIFF DEPARTMENT",
                "CALAVERAS SHERIFF OFFICE",
                "CALAVERAS SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.calaverasgov.us/Departments/Sheriff",
            "website_label": null,
            "phone": "(209) 754-6500",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "colusa_county_sheriff",
            "name": "Colusa County Sheriff's Office",
            "short": "Colusa County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Colusa",
            "aliases": [
                "COLUSA COUNTY SHERIFF",
                "COLUSA COUNTY SHERIFF DEPARTMENT",
                "COLUSA COUNTY SHERIFF OFFICE",
                "COLUSA COUNTY SO",
                "COLUSA SHERIFF",
                "COLUSA SHERIFF DEPARTMENT",
                "COLUSA SHERIFF OFFICE",
                "COLUSA SO"
            ],
            "county_aliases": [],
            "tat_text": "60 - 90 days",
            "tat_min_days": 60,
            "tat_max_days": 90,
            "wait_text": "60 to 90 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.colusacountysheriff.com/",
            "website_label": null,
            "phone": "(530) 458-0200",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "contra_costa_county_sheriff",
            "name": "Contra Costa County Sheriff's Office",
            "short": "Contra Costa County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Contra Costa",
            "aliases": [
                "CCCSO",
                "CONTRA COSTA COUNTY SHERIFF",
                "CONTRA COSTA COUNTY SHERIFF DEPARTMENT",
                "CONTRA COSTA COUNTY SHERIFF OFFICE",
                "CONTRA COSTA COUNTY SO",
                "CONTRA COSTA SHERIFF",
                "CONTRA COSTA SHERIFF DEPARTMENT",
                "CONTRA COSTA SHERIFF OFFICE",
                "CONTRA COSTA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.cocosheriff.org/",
            "website_label": null,
            "phone": "(925) 646-2441",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "del_norte_county_sheriff",
            "name": "Del Norte County Sheriff's Office",
            "short": "Del Norte County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Del Norte",
            "aliases": [
                "DEL NORTE COUNTY SHERIFF",
                "DEL NORTE COUNTY SHERIFF DEPARTMENT",
                "DEL NORTE COUNTY SHERIFF OFFICE",
                "DEL NORTE COUNTY SO",
                "DEL NORTE SHERIFF",
                "DEL NORTE SHERIFF DEPARTMENT",
                "DEL NORTE SHERIFF OFFICE",
                "DEL NORTE SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.delnortecountysheriff.com/",
            "website_label": null,
            "phone": "(707) 464-4191",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "el_dorado_county_sheriff",
            "name": "El Dorado County Sheriff's Office",
            "short": "El Dorado County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "El Dorado",
            "aliases": [
                "EL DORADO COUNTY SHERIFF",
                "EL DORADO COUNTY SHERIFF DEPARTMENT",
                "EL DORADO COUNTY SHERIFF OFFICE",
                "EL DORADO COUNTY SO",
                "EL DORADO SHERIFF",
                "EL DORADO SHERIFF DEPARTMENT",
                "EL DORADO SHERIFF OFFICE",
                "EL DORADO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.eldoradosheriff.org/",
            "website_label": null,
            "phone": "(530) 621-5655",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "fresno_county_sheriff",
            "name": "Fresno County Sheriff's Office",
            "short": "Fresno County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Fresno",
            "aliases": [
                "FRESNO COUNTY SHERIFF",
                "FRESNO COUNTY SHERIFF DEPARTMENT",
                "FRESNO COUNTY SHERIFF OFFICE",
                "FRESNO COUNTY SO",
                "FRESNO SHERIFF",
                "FRESNO SHERIFF DEPARTMENT",
                "FRESNO SHERIFF OFFICE",
                "FRESNO SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.fresnosheriff.org/",
            "website_label": null,
            "phone": "(559) 600-3111",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "glenn_county_sheriff",
            "name": "Glenn County Sheriff's Office",
            "short": "Glenn County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Glenn",
            "aliases": [
                "GLENN COUNTY SHERIFF",
                "GLENN COUNTY SHERIFF DEPARTMENT",
                "GLENN COUNTY SHERIFF OFFICE",
                "GLENN COUNTY SO",
                "GLENN SHERIFF",
                "GLENN SHERIFF DEPARTMENT",
                "GLENN SHERIFF OFFICE",
                "GLENN SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.countyofglenn.net/dept/sheriff",
            "website_label": null,
            "phone": "(530) 934-6431",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "humboldt_county_sheriff",
            "name": "Humboldt County Sheriff's Office",
            "short": "Humboldt County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Humboldt",
            "aliases": [
                "HUMBOLDT COUNTY SHERIFF",
                "HUMBOLDT COUNTY SHERIFF DEPARTMENT",
                "HUMBOLDT COUNTY SHERIFF OFFICE",
                "HUMBOLDT COUNTY SO",
                "HUMBOLDT SHERIFF",
                "HUMBOLDT SHERIFF DEPARTMENT",
                "HUMBOLDT SHERIFF OFFICE",
                "HUMBOLDT SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://humboldtgov.org/Sheriff",
            "website_label": null,
            "phone": "(707) 445-7251",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "imperial_county_sheriff",
            "name": "Imperial County Sheriff's Office",
            "short": "Imperial County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Imperial",
            "aliases": [
                "IMPERIAL COUNTY SHERIFF",
                "IMPERIAL COUNTY SHERIFF DEPARTMENT",
                "IMPERIAL COUNTY SHERIFF OFFICE",
                "IMPERIAL COUNTY SO",
                "IMPERIAL SHERIFF",
                "IMPERIAL SHERIFF DEPARTMENT",
                "IMPERIAL SHERIFF OFFICE",
                "IMPERIAL SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.icso.org/",
            "website_label": null,
            "phone": "(442) 265-1911",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "inyo_county_sheriff",
            "name": "Inyo County Sheriff's Office",
            "short": "Inyo County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Inyo",
            "aliases": [
                "INYO COUNTY SHERIFF",
                "INYO COUNTY SHERIFF DEPARTMENT",
                "INYO COUNTY SHERIFF OFFICE",
                "INYO COUNTY SO",
                "INYO SHERIFF",
                "INYO SHERIFF DEPARTMENT",
                "INYO SHERIFF OFFICE",
                "INYO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.inyosheriff.org/",
            "website_label": null,
            "phone": "(760) 878-0383",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "kern_county_sheriff",
            "name": "Kern County Sheriff's Office",
            "short": "Kern County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Kern",
            "aliases": [
                "KERN COUNTY SHERIFF",
                "KERN COUNTY SHERIFF DEPARTMENT",
                "KERN COUNTY SHERIFF OFFICE",
                "KERN COUNTY SO",
                "KERN SHERIFF",
                "KERN SHERIFF DEPARTMENT",
                "KERN SHERIFF OFFICE",
                "KERN SO"
            ],
            "county_aliases": [
                "KCSO"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.kernsheriff.org/",
            "website_label": null,
            "phone": "(661) 861-3110",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "kings_county_sheriff",
            "name": "Kings County Sheriff's Office",
            "short": "Kings County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Kings",
            "aliases": [
                "KINGS COUNTY SHERIFF",
                "KINGS COUNTY SHERIFF DEPARTMENT",
                "KINGS COUNTY SHERIFF OFFICE",
                "KINGS COUNTY SO",
                "KINGS SHERIFF",
                "KINGS SHERIFF DEPARTMENT",
                "KINGS SHERIFF OFFICE",
                "KINGS SO"
            ],
            "county_aliases": [
                "KCSO"
            ],
            "tat_text": "60 - 90 days",
            "tat_min_days": 60,
            "tat_max_days": 90,
            "wait_text": "60 to 90 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.kingscountysheriff.com/",
            "website_label": null,
            "phone": "(559) 852-2727",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "lake_county_sheriff",
            "name": "Lake County Sheriff's Office",
            "short": "Lake County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Lake",
            "aliases": [
                "LAKE COUNTY SHERIFF",
                "LAKE COUNTY SHERIFF DEPARTMENT",
                "LAKE COUNTY SHERIFF OFFICE",
                "LAKE COUNTY SO",
                "LAKE SHERIFF",
                "LAKE SHERIFF DEPARTMENT",
                "LAKE SHERIFF OFFICE",
                "LAKE SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.lakesheriff.com/",
            "website_label": null,
            "phone": "(707) 263-5491",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "lassen_county_sheriff",
            "name": "Lassen County Sheriff's Office",
            "short": "Lassen County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Lassen",
            "aliases": [
                "LASSEN COUNTY SHERIFF",
                "LASSEN COUNTY SHERIFF DEPARTMENT",
                "LASSEN COUNTY SHERIFF OFFICE",
                "LASSEN COUNTY SO",
                "LASSEN SHERIFF",
                "LASSEN SHERIFF DEPARTMENT",
                "LASSEN SHERIFF OFFICE",
                "LASSEN SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://lassencares.org/sheriff",
            "website_label": null,
            "phone": "(530) 257-6121",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "madera_county_sheriff",
            "name": "Madera County Sheriff's Office",
            "short": "Madera County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Madera",
            "aliases": [
                "MADERA COUNTY SHERIFF",
                "MADERA COUNTY SHERIFF DEPARTMENT",
                "MADERA COUNTY SHERIFF OFFICE",
                "MADERA COUNTY SO",
                "MADERA SHERIFF",
                "MADERA SHERIFF DEPARTMENT",
                "MADERA SHERIFF OFFICE",
                "MADERA SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.maderacounty.com/government/departments/sheriff",
            "website_label": null,
            "phone": "(559) 675-7770",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "marin_county_sheriff",
            "name": "Marin County Sheriff's Office",
            "short": "Marin County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Marin",
            "aliases": [
                "MARIN COUNTY SHERIFF",
                "MARIN COUNTY SHERIFF DEPARTMENT",
                "MARIN COUNTY SHERIFF OFFICE",
                "MARIN COUNTY SO",
                "MARIN SHERIFF",
                "MARIN SHERIFF DEPARTMENT",
                "MARIN SHERIFF OFFICE",
                "MARIN SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.marinsheriff.org/",
            "website_label": null,
            "phone": "(415) 479-2311",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "mariposa_county_sheriff",
            "name": "Mariposa County Sheriff's Office",
            "short": "Mariposa County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Mariposa",
            "aliases": [
                "MARIPOSA COUNTY SHERIFF",
                "MARIPOSA COUNTY SHERIFF DEPARTMENT",
                "MARIPOSA COUNTY SHERIFF OFFICE",
                "MARIPOSA COUNTY SO",
                "MARIPOSA SHERIFF",
                "MARIPOSA SHERIFF DEPARTMENT",
                "MARIPOSA SHERIFF OFFICE",
                "MARIPOSA SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.mariposacounty.org/75/Sheriff",
            "website_label": null,
            "phone": "(209) 966-3615",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "mendocino_county_sheriff",
            "name": "Mendocino County Sheriff's Office",
            "short": "Mendocino County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Mendocino",
            "aliases": [
                "MENDOCINO COUNTY SHERIFF",
                "MENDOCINO COUNTY SHERIFF DEPARTMENT",
                "MENDOCINO COUNTY SHERIFF OFFICE",
                "MENDOCINO COUNTY SO",
                "MENDOCINO SHERIFF",
                "MENDOCINO SHERIFF DEPARTMENT",
                "MENDOCINO SHERIFF OFFICE",
                "MENDOCINO SO"
            ],
            "county_aliases": [],
            "tat_text": "30 - 60 days",
            "tat_min_days": 30,
            "tat_max_days": 60,
            "wait_text": "30 to 60 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.mendocinocounty.org/government/sheriff",
            "website_label": null,
            "phone": "(707) 463-4086",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "merced_county_sheriff",
            "name": "Merced County Sheriff's Office",
            "short": "Merced County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Merced",
            "aliases": [
                "MERCED COUNTY SHERIFF",
                "MERCED COUNTY SHERIFF DEPARTMENT",
                "MERCED COUNTY SHERIFF OFFICE",
                "MERCED COUNTY SO",
                "MERCED SHERIFF",
                "MERCED SHERIFF DEPARTMENT",
                "MERCED SHERIFF OFFICE",
                "MERCED SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.countyofmerced.com/96/Sheriff",
            "website_label": null,
            "phone": "(209) 385-7445",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "modoc_county_sheriff",
            "name": "Modoc County Sheriff's Office",
            "short": "Modoc County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Modoc",
            "aliases": [
                "MODOC COUNTY SHERIFF",
                "MODOC COUNTY SHERIFF DEPARTMENT",
                "MODOC COUNTY SHERIFF OFFICE",
                "MODOC COUNTY SO",
                "MODOC SHERIFF",
                "MODOC SHERIFF DEPARTMENT",
                "MODOC SHERIFF OFFICE",
                "MODOC SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.co.modoc.ca.us/departments/sheriff",
            "website_label": null,
            "phone": "(530) 233-4416",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "mono_county_sheriff",
            "name": "Mono County Sheriff's Office",
            "short": "Mono County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Mono",
            "aliases": [
                "MONO COUNTY SHERIFF",
                "MONO COUNTY SHERIFF DEPARTMENT",
                "MONO COUNTY SHERIFF OFFICE",
                "MONO COUNTY SO",
                "MONO SHERIFF",
                "MONO SHERIFF DEPARTMENT",
                "MONO SHERIFF OFFICE",
                "MONO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.monocounty.ca.gov/sheriff",
            "website_label": null,
            "phone": "(760) 932-7549",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "monterey_county_sheriff",
            "name": "Monterey County Sheriff's Office",
            "short": "Monterey County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Monterey",
            "aliases": [
                "MONTEREY COUNTY SHERIFF",
                "MONTEREY COUNTY SHERIFF DEPARTMENT",
                "MONTEREY COUNTY SHERIFF OFFICE",
                "MONTEREY COUNTY SO",
                "MONTEREY SHERIFF",
                "MONTEREY SHERIFF DEPARTMENT",
                "MONTEREY SHERIFF OFFICE",
                "MONTEREY SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.montereysheriff.org/",
            "website_label": null,
            "phone": "(831) 755-5111",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "napa_county_sheriff",
            "name": "Napa County Sheriff's Office",
            "short": "Napa County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Napa",
            "aliases": [
                "NAPA COUNTY SHERIFF",
                "NAPA COUNTY SHERIFF DEPARTMENT",
                "NAPA COUNTY SHERIFF OFFICE",
                "NAPA COUNTY SO",
                "NAPA SHERIFF",
                "NAPA SHERIFF DEPARTMENT",
                "NAPA SHERIFF OFFICE",
                "NAPA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.napacounty.gov/sheriff",
            "website_label": null,
            "phone": "(707) 253-4451",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "nevada_county_sheriff",
            "name": "Nevada County Sheriff's Office",
            "short": "Nevada County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Nevada",
            "aliases": [
                "NEVADA COUNTY SHERIFF",
                "NEVADA COUNTY SHERIFF DEPARTMENT",
                "NEVADA COUNTY SHERIFF OFFICE",
                "NEVADA COUNTY SO",
                "NEVADA SHERIFF",
                "NEVADA SHERIFF DEPARTMENT",
                "NEVADA SHERIFF OFFICE",
                "NEVADA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.nevcounty.com/sheriff",
            "website_label": null,
            "phone": "(530) 265-7880",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "orange_county_sheriff",
            "name": "Orange County Sheriff's Department",
            "short": "OCSD",
            "type": "sheriff",
            "city": null,
            "county": "Orange",
            "aliases": [
                "OCSD",
                "OCSO",
                "ORANGE COUNTY SHERIFF",
                "ORANGE COUNTY SHERIFF DEPARTMENT",
                "ORANGE COUNTY SHERIFF OFFICE",
                "ORANGE COUNTY SO",
                "ORANGE SHERIFF",
                "ORANGE SHERIFF DEPARTMENT",
                "ORANGE SHERIFF OFFICE",
                "ORANGE SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.ocsheriff.gov/records",
            "website_label": null,
            "phone": "(714) 647-7000",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "placer_county_sheriff",
            "name": "Placer County Sheriff's Office",
            "short": "Placer County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Placer",
            "aliases": [
                "PLACER COUNTY SHERIFF",
                "PLACER COUNTY SHERIFF DEPARTMENT",
                "PLACER COUNTY SHERIFF OFFICE",
                "PLACER COUNTY SO",
                "PLACER SHERIFF",
                "PLACER SHERIFF DEPARTMENT",
                "PLACER SHERIFF OFFICE",
                "PLACER SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.placer.ca.gov/sheriff",
            "website_label": null,
            "phone": "(530) 889-7800",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "plumas_county_sheriff",
            "name": "Plumas County Sheriff's Office",
            "short": "Plumas County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Plumas",
            "aliases": [
                "PLUMAS COUNTY SHERIFF",
                "PLUMAS COUNTY SHERIFF DEPARTMENT",
                "PLUMAS COUNTY SHERIFF OFFICE",
                "PLUMAS COUNTY SO",
                "PLUMAS SHERIFF",
                "PLUMAS SHERIFF DEPARTMENT",
                "PLUMAS SHERIFF OFFICE",
                "PLUMAS SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.plumascounty.us/249/Sheriff",
            "website_label": null,
            "phone": "(530) 283-6300",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "riverside_county_sheriff",
            "name": "Riverside County Sheriff's Department",
            "short": "Riverside County Sheriff's Department",
            "type": "sheriff",
            "city": null,
            "county": "Riverside",
            "aliases": [
                "RCSD",
                "RIVERSIDE COUNTY SHERIFF",
                "RIVERSIDE COUNTY SHERIFF DEPARTMENT",
                "RIVERSIDE COUNTY SHERIFF OFFICE",
                "RIVERSIDE COUNTY SO",
                "RIVERSIDE SHERIFF",
                "RIVERSIDE SHERIFF DEPARTMENT",
                "RIVERSIDE SHERIFF OFFICE",
                "RIVERSIDE SO",
                "RSO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.riversidesheriff.org/",
            "website_label": null,
            "phone": "(951) 776-1099",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "sacramento_county_sheriff",
            "name": "Sacramento County Sheriff's Office",
            "short": "Sacramento County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Sacramento",
            "aliases": [
                "SACRAMENTO COUNTY SHERIFF",
                "SACRAMENTO COUNTY SHERIFF DEPARTMENT",
                "SACRAMENTO COUNTY SHERIFF OFFICE",
                "SACRAMENTO COUNTY SO",
                "SACRAMENTO SHERIFF",
                "SACRAMENTO SHERIFF DEPARTMENT",
                "SACRAMENTO SHERIFF OFFICE",
                "SACRAMENTO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sacsheriff.com/",
            "website_label": null,
            "phone": "(916) 874-5115",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_benito_county_sheriff",
            "name": "San Benito County Sheriff's Office",
            "short": "San Benito County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "San Benito",
            "aliases": [
                "SAN BENITO COUNTY SHERIFF",
                "SAN BENITO COUNTY SHERIFF DEPARTMENT",
                "SAN BENITO COUNTY SHERIFF OFFICE",
                "SAN BENITO COUNTY SO",
                "SAN BENITO SHERIFF",
                "SAN BENITO SHERIFF DEPARTMENT",
                "SAN BENITO SHERIFF OFFICE",
                "SAN BENITO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sanbenito.com/sheriff",
            "website_label": null,
            "phone": "(831) 636-4087",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_bernardino_county_sheriff",
            "name": "San Bernardino County Sheriff's Department",
            "short": "San Bernardino County Sheriff's Department",
            "type": "sheriff",
            "city": null,
            "county": "San Bernardino",
            "aliases": [
                "SAN BERNARDINO COUNTY SHERIFF",
                "SAN BERNARDINO COUNTY SHERIFF DEPARTMENT",
                "SAN BERNARDINO COUNTY SHERIFF OFFICE",
                "SAN BERNARDINO COUNTY SO",
                "SAN BERNARDINO SHERIFF",
                "SAN BERNARDINO SHERIFF DEPARTMENT",
                "SAN BERNARDINO SHERIFF OFFICE",
                "SAN BERNARDINO SO",
                "SBCS",
                "SBCSD"
            ],
            "county_aliases": [
                "SBCSO",
                "SBSD"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sbcounty.gov/sheriff",
            "website_label": null,
            "phone": "(909) 387-8313",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_diego_county_sheriff",
            "name": "San Diego County Sheriff's Office",
            "short": "San Diego County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "San Diego",
            "aliases": [
                "SAN DIEGO COUNTY SHERIFF",
                "SAN DIEGO COUNTY SHERIFF DEPARTMENT",
                "SAN DIEGO COUNTY SHERIFF OFFICE",
                "SAN DIEGO COUNTY SO",
                "SAN DIEGO SHERIFF",
                "SAN DIEGO SHERIFF DEPARTMENT",
                "SAN DIEGO SHERIFF OFFICE",
                "SAN DIEGO SO",
                "SDCSD",
                "SDSD",
                "SDSO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sdsheriff.gov/rec",
            "website_label": null,
            "phone": "(858) 565-5200",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_francisco_sheriff",
            "name": "San Francisco Sheriff's Office",
            "short": "San Francisco Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "San Francisco",
            "aliases": [
                "SAN FRANCISCO COUNTY SHERIFF",
                "SAN FRANCISCO COUNTY SHERIFF DEPARTMENT",
                "SAN FRANCISCO COUNTY SHERIFF OFFICE",
                "SAN FRANCISCO COUNTY SO",
                "SAN FRANCISCO SHERIFF",
                "SAN FRANCISCO SHERIFF DEPARTMENT",
                "SAN FRANCISCO SHERIFF OFFICE",
                "SAN FRANCISCO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sfsheriff.com/services/records",
            "website_label": null,
            "phone": "(415) 554-7225",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_joaquin_county_sheriff",
            "name": "San Joaquin County Sheriff's Office",
            "short": "San Joaquin County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "San Joaquin",
            "aliases": [
                "SAN JOAQUIN COUNTY SHERIFF",
                "SAN JOAQUIN COUNTY SHERIFF DEPARTMENT",
                "SAN JOAQUIN COUNTY SHERIFF OFFICE",
                "SAN JOAQUIN COUNTY SO",
                "SAN JOAQUIN SHERIFF",
                "SAN JOAQUIN SHERIFF DEPARTMENT",
                "SAN JOAQUIN SHERIFF OFFICE",
                "SAN JOAQUIN SO",
                "SJCSO",
                "SJSO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sjgov.org/sheriff/services/records",
            "website_label": null,
            "phone": "(209) 468-4400",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_luis_obispo_county_sheriff",
            "name": "San Luis Obispo County Sheriff's Office",
            "short": "San Luis Obispo County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "San Luis Obispo",
            "aliases": [
                "SAN LUIS OBISPO COUNTY SHERIFF",
                "SAN LUIS OBISPO COUNTY SHERIFF DEPARTMENT",
                "SAN LUIS OBISPO COUNTY SHERIFF OFFICE",
                "SAN LUIS OBISPO COUNTY SO",
                "SAN LUIS OBISPO SHERIFF",
                "SAN LUIS OBISPO SHERIFF DEPARTMENT",
                "SAN LUIS OBISPO SHERIFF OFFICE",
                "SAN LUIS OBISPO SO",
                "SLOSO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.slosheriff.org/records/",
            "website_label": null,
            "phone": "(805) 781-4550",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "san_mateo_county_sheriff",
            "name": "San Mateo County Sheriff's Office",
            "short": "San Mateo County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "San Mateo",
            "aliases": [
                "SAN MATEO COUNTY SHERIFF",
                "SAN MATEO COUNTY SHERIFF DEPARTMENT",
                "SAN MATEO COUNTY SHERIFF OFFICE",
                "SAN MATEO COUNTY SO",
                "SAN MATEO SHERIFF",
                "SAN MATEO SHERIFF DEPARTMENT",
                "SAN MATEO SHERIFF OFFICE",
                "SAN MATEO SO",
                "SMCSO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.smcsheriff.com/records",
            "website_label": null,
            "phone": "(650) 363-4911",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "santa_barbara_county_sheriff",
            "name": "Santa Barbara County Sheriff's Office",
            "short": "Santa Barbara County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Santa Barbara",
            "aliases": [
                "SANTA BARBARA COUNTY SHERIFF",
                "SANTA BARBARA COUNTY SHERIFF DEPARTMENT",
                "SANTA BARBARA COUNTY SHERIFF OFFICE",
                "SANTA BARBARA COUNTY SO",
                "SANTA BARBARA SHERIFF",
                "SANTA BARBARA SHERIFF DEPARTMENT",
                "SANTA BARBARA SHERIFF OFFICE",
                "SANTA BARBARA SO"
            ],
            "county_aliases": [
                "SBCSO",
                "SBSD",
                "SBSO"
            ],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sbsheriff.org/records/",
            "website_label": null,
            "phone": "(805) 683-2724",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "santa_clara_county_sheriff",
            "name": "Santa Clara County Sheriff's Office",
            "short": "Santa Clara County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Santa Clara",
            "aliases": [
                "SANTA CLARA COUNTY SHERIFF",
                "SANTA CLARA COUNTY SHERIFF DEPARTMENT",
                "SANTA CLARA COUNTY SHERIFF OFFICE",
                "SANTA CLARA COUNTY SO",
                "SANTA CLARA SHERIFF",
                "SANTA CLARA SHERIFF DEPARTMENT",
                "SANTA CLARA SHERIFF OFFICE",
                "SANTA CLARA SO",
                "SCCSO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://sheriff.santaclaracounty.gov/services/records",
            "website_label": null,
            "phone": "(408) 299-2311",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "santa_cruz_county_sheriff",
            "name": "Santa Cruz County Sheriff's Office",
            "short": "Santa Cruz County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Santa Cruz",
            "aliases": [
                "SANTA CRUZ COUNTY SHERIFF",
                "SANTA CRUZ COUNTY SHERIFF DEPARTMENT",
                "SANTA CRUZ COUNTY SHERIFF OFFICE",
                "SANTA CRUZ COUNTY SO",
                "SANTA CRUZ SHERIFF",
                "SANTA CRUZ SHERIFF DEPARTMENT",
                "SANTA CRUZ SHERIFF OFFICE",
                "SANTA CRUZ SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.scsheriff.com/records",
            "website_label": null,
            "phone": "(831) 471-1121",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "shasta_county_sheriff",
            "name": "Shasta County Sheriff's Office",
            "short": "Shasta County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Shasta",
            "aliases": [
                "SHASTA COUNTY SHERIFF",
                "SHASTA COUNTY SHERIFF DEPARTMENT",
                "SHASTA COUNTY SHERIFF OFFICE",
                "SHASTA COUNTY SO",
                "SHASTA SHERIFF",
                "SHASTA SHERIFF DEPARTMENT",
                "SHASTA SHERIFF OFFICE",
                "SHASTA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.shastacounty.gov/sheriff/records",
            "website_label": null,
            "phone": "(530) 245-6540",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "sierra_county_sheriff",
            "name": "Sierra County Sheriff's Office",
            "short": "Sierra County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Sierra",
            "aliases": [
                "SIERRA COUNTY SHERIFF",
                "SIERRA COUNTY SHERIFF DEPARTMENT",
                "SIERRA COUNTY SHERIFF OFFICE",
                "SIERRA COUNTY SO",
                "SIERRA SHERIFF",
                "SIERRA SHERIFF DEPARTMENT",
                "SIERRA SHERIFF OFFICE",
                "SIERRA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sierracounty.ca.gov/240/Sheriff",
            "website_label": null,
            "phone": "(530) 289-3700",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "siskiyou_county_sheriff",
            "name": "Siskiyou County Sheriff's Office",
            "short": "Siskiyou County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Siskiyou",
            "aliases": [
                "SISKIYOU COUNTY SHERIFF",
                "SISKIYOU COUNTY SHERIFF DEPARTMENT",
                "SISKIYOU COUNTY SHERIFF OFFICE",
                "SISKIYOU COUNTY SO",
                "SISKIYOU SHERIFF",
                "SISKIYOU SHERIFF DEPARTMENT",
                "SISKIYOU SHERIFF OFFICE",
                "SISKIYOU SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sisqgov.org/sheriff",
            "website_label": null,
            "phone": "(530) 842-8300",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "solano_county_sheriff",
            "name": "Solano County Sheriff's Office",
            "short": "Solano County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Solano",
            "aliases": [
                "SOLANO COUNTY SHERIFF",
                "SOLANO COUNTY SHERIFF DEPARTMENT",
                "SOLANO COUNTY SHERIFF OFFICE",
                "SOLANO COUNTY SO",
                "SOLANO SHERIFF",
                "SOLANO SHERIFF DEPARTMENT",
                "SOLANO SHERIFF OFFICE",
                "SOLANO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.solanocounty.com/depts/sheriff",
            "website_label": null,
            "phone": "(707) 421-7090",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "sonoma_county_sheriff",
            "name": "Sonoma County Sheriff's Office",
            "short": "Sonoma County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Sonoma",
            "aliases": [
                "SONOMA COUNTY SHERIFF",
                "SONOMA COUNTY SHERIFF DEPARTMENT",
                "SONOMA COUNTY SHERIFF OFFICE",
                "SONOMA COUNTY SO",
                "SONOMA SHERIFF",
                "SONOMA SHERIFF DEPARTMENT",
                "SONOMA SHERIFF OFFICE",
                "SONOMA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.sonomasheriff.org/records",
            "website_label": null,
            "phone": "(707) 565-2121",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "stanislaus_county_sheriff",
            "name": "Stanislaus County Sheriff's Office",
            "short": "Stanislaus County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Stanislaus",
            "aliases": [
                "STANISLAUS COUNTY SHERIFF",
                "STANISLAUS COUNTY SHERIFF DEPARTMENT",
                "STANISLAUS COUNTY SHERIFF OFFICE",
                "STANISLAUS COUNTY SO",
                "STANISLAUS SHERIFF",
                "STANISLAUS SHERIFF DEPARTMENT",
                "STANISLAUS SHERIFF OFFICE",
                "STANISLAUS SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.stanislaussheriff.com/records",
            "website_label": null,
            "phone": "(209) 552-2468",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "sutter_county_sheriff",
            "name": "Sutter County Sheriff's Office",
            "short": "Sutter County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Sutter",
            "aliases": [
                "SUTTER COUNTY SHERIFF",
                "SUTTER COUNTY SHERIFF DEPARTMENT",
                "SUTTER COUNTY SHERIFF OFFICE",
                "SUTTER COUNTY SO",
                "SUTTER SHERIFF",
                "SUTTER SHERIFF DEPARTMENT",
                "SUTTER SHERIFF OFFICE",
                "SUTTER SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.suttersheriff.org/records",
            "website_label": null,
            "phone": "(530) 822-7307",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "tehama_county_sheriff",
            "name": "Tehama County Sheriff's Office",
            "short": "Tehama County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Tehama",
            "aliases": [
                "TEHAMA COUNTY SHERIFF",
                "TEHAMA COUNTY SHERIFF DEPARTMENT",
                "TEHAMA COUNTY SHERIFF OFFICE",
                "TEHAMA COUNTY SO",
                "TEHAMA SHERIFF",
                "TEHAMA SHERIFF DEPARTMENT",
                "TEHAMA SHERIFF OFFICE",
                "TEHAMA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.tehamaso.org/",
            "website_label": null,
            "phone": "(530) 529-7900",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "trinity_county_sheriff",
            "name": "Trinity County Sheriff's Office",
            "short": "Trinity County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Trinity",
            "aliases": [
                "TRINITY COUNTY SHERIFF",
                "TRINITY COUNTY SHERIFF DEPARTMENT",
                "TRINITY COUNTY SHERIFF OFFICE",
                "TRINITY COUNTY SO",
                "TRINITY SHERIFF",
                "TRINITY SHERIFF DEPARTMENT",
                "TRINITY SHERIFF OFFICE",
                "TRINITY SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.trinitycounty.org/Sheriff",
            "website_label": null,
            "phone": "(530) 623-2611",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "tulare_county_sheriff",
            "name": "Tulare County Sheriff's Office",
            "short": "Tulare County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Tulare",
            "aliases": [
                "TULARE COUNTY SHERIFF",
                "TULARE COUNTY SHERIFF DEPARTMENT",
                "TULARE COUNTY SHERIFF OFFICE",
                "TULARE COUNTY SO",
                "TULARE SHERIFF",
                "TULARE SHERIFF DEPARTMENT",
                "TULARE SHERIFF OFFICE",
                "TULARE SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://tularecounty.ca.gov/sheriff/",
            "website_label": null,
            "phone": "(559) 733-6218",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "tuolumne_county_sheriff",
            "name": "Tuolumne County Sheriff's Office",
            "short": "Tuolumne County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Tuolumne",
            "aliases": [
                "TUOLUMNE COUNTY SHERIFF",
                "TUOLUMNE COUNTY SHERIFF DEPARTMENT",
                "TUOLUMNE COUNTY SHERIFF OFFICE",
                "TUOLUMNE COUNTY SO",
                "TUOLUMNE SHERIFF",
                "TUOLUMNE SHERIFF DEPARTMENT",
                "TUOLUMNE SHERIFF OFFICE",
                "TUOLUMNE SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.tuolumnecounty.ca.gov/161/Sheriff",
            "website_label": null,
            "phone": "(209) 533-5815",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "ventura_county_sheriff",
            "name": "Ventura County Sheriff's Office",
            "short": "Ventura County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Ventura",
            "aliases": [
                "VCSO",
                "VENTURA COUNTY SHERIFF",
                "VENTURA COUNTY SHERIFF DEPARTMENT",
                "VENTURA COUNTY SHERIFF OFFICE",
                "VENTURA COUNTY SO",
                "VENTURA SHERIFF",
                "VENTURA SHERIFF DEPARTMENT",
                "VENTURA SHERIFF OFFICE",
                "VENTURA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.venturasheriff.org/records/",
            "website_label": null,
            "phone": "(805) 654-9511",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "yolo_county_sheriff",
            "name": "Yolo County Sheriff's Office",
            "short": "Yolo County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Yolo",
            "aliases": [
                "YOLO COUNTY SHERIFF",
                "YOLO COUNTY SHERIFF DEPARTMENT",
                "YOLO COUNTY SHERIFF OFFICE",
                "YOLO COUNTY SO",
                "YOLO SHERIFF",
                "YOLO SHERIFF DEPARTMENT",
                "YOLO SHERIFF OFFICE",
                "YOLO SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.yolocountysheriff.com/records",
            "website_label": null,
            "phone": "(530) 666-8282",
            "sheet": "Sheet2",
            "conflicts": []
        },
        {
            "id": "yuba_county_sheriff",
            "name": "Yuba County Sheriff's Office",
            "short": "Yuba County Sheriff's Office",
            "type": "sheriff",
            "city": null,
            "county": "Yuba",
            "aliases": [
                "YUBA COUNTY SHERIFF",
                "YUBA COUNTY SHERIFF DEPARTMENT",
                "YUBA COUNTY SHERIFF OFFICE",
                "YUBA COUNTY SO",
                "YUBA SHERIFF",
                "YUBA SHERIFF DEPARTMENT",
                "YUBA SHERIFF OFFICE",
                "YUBA SO"
            ],
            "county_aliases": [],
            "tat_text": "15 - 30 days",
            "tat_min_days": 15,
            "tat_max_days": 30,
            "wait_text": "15 to 30 days",
            "status": "Needs Confirmation",
            "request_method": null,
            "website": "https://www.yubacountysheriff.com/records",
            "website_label": null,
            "phone": "(530) 749-7777",
            "sheet": "Sheet2",
            "conflicts": []
        }
    ]
};
//# sourceMappingURL=ca_pd_agencies.js.map